import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Hire from "./pages/Hire";
import Jobs from "./pages/Jobs";

import TawkChat from "./components/common/TawkChat";

function App() {
  return (
    <>
      <TawkChat />

      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hire" element={<Hire />} />
          <Route path="/jobs" element={<Jobs />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;